<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-row class="align-center">
      <v-col
        cols="2"
        class="pb-2"
      >
        <span class="fw600 f7">Tablets</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="20"
            :search="search"
            :loading="loading"
            dense
          >
            <template #[`item.id`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.id }}
              </text-highlight>
            </template>
            <template #[`item.name`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.name }}
              </text-highlight>
            </template>
            <template #[`item.location_name`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.location_name }}
              </text-highlight>
            </template>
            <template #[`item.location_entrance_name`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.location_entrance_name }}
              </text-highlight>
            </template>
            <template #[`item.ip`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.ip }}
              </text-highlight>
            </template>
            <template #[`item.user_name`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.user_name ? item.user_name : '' }}
              </text-highlight>
            </template>
            <template #[`item.created_at`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.created_at }}
              </text-highlight>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="error"
                outlined
                small
                @click="softDelete(item.id)"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {
  },
  data: () => ({
    items: [],
    inventoryClassId: null,
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Name', value: 'name' },
      { text: 'Location', value: 'location_name' },
      { text: 'Entrance', value: 'location_entrance_name' },
      { text: 'Created At', value: 'created_at' },
      { text: 'Created By', value: 'user_name' },
      { text: 'Actions', value: 'actions', align: 'end' },
    ],
    footer: {
      'items-per-page-options': [10, 20, 50, 100, 500, 1000, -1],
    },
    loading: false,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
    }),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.get();
    },

    async get() {
      this.loading = true;
      const submitModel = {
        filters: {
        },
      };
      this.items = await this.$api.device.read(submitModel);
      this.loading = false;
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      if (!id) return;

      const res = await this.$api.device.delete(id);

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    success() {
      this.$bus.$emit('showSuccess');
      this.get();
    },
  },
};
</script>
